'use strict';

var angular = require('angular');
module.exports = angular.module('AVRO.Dashboard.DashboardCommonComponents', ['AVRO.Common.DataRetriever']).factory('DashboardCommonService', require('./services/DashboardCommonService')).factory('DashboardAggregatingService', require('./services/DashboardAggregatingService')).constant('DashboardConstants', require('./constants/DashboardConstants'));